export enum SystemAlertType {
    FEMA = 'region',
    STATE = 'state',
    COUNTY = 'county',
}
